import axios from "axios";
import { BASE_URL } from "./core";

/**
 * Admin API client for endpoints that use X-API-Key (not Azure AD Bearer).
 * Set REACT_APP_API_KEY in .env.qa.local / .env.production.local.
 */
const adminApiKeyAxiosInstance = axios.create({
  baseURL: BASE_URL,
});

adminApiKeyAxiosInstance.interceptors.request.use(
  (config) => {
    const apiKey = process.env.REACT_APP_API_KEY;
    if (!apiKey) {
      return Promise.reject(
        new Error("REACT_APP_API_KEY is not configured in the environment file")
      );
    }
    config.headers["X-API-Key"] = apiKey;
    return config;
  },
  (error) => Promise.reject(error)
);

export default adminApiKeyAxiosInstance;
